export const isUserAdmin = (user: any) => {
  return user && user.authority !== 'USER';
};

export const isUserClient = (user: any) => {
  return user && user.authority === 'USER';
};
